import * as yup from 'yup';

import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import styles from './GetToken.module.scss';

import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {useLoginByAnotherUserMutation} from 'store/slices/profile';
import ButtonWithProgress from 'components/ButtonWithProgress/ButtonWithProgress';
import {useAppDispatch} from 'store/store';
import {setAuthData} from 'store/slices/authSlice';
import {useNavigate} from 'react-router-dom';
import {api} from 'store/slices/api';
import {createButton} from 'styles/MUIStyles/buttons';

const validationSchema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Required'),
});

const GetTokenPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [getToken, {isLoading, data, isSuccess}] =
    useLoginByAnotherUserMutation();

  const form = useForm({
    defaultValues: {
      //   currentEmail: '',
      email: '',
    },
    resolver: yupResolver(validationSchema),
  });

  const signIn = () => {
    dispatch(setAuthData(data));
    dispatch(api.util.invalidateTags(['Profile']));
    navigate('/');
  };

  return (
    <Box>
      <form
        onSubmit={form.handleSubmit(async (data) => {
          const response = await getToken({email: data.email});
          // @ts-ignore
          if (response.error?.status === 400) {
            form.setError('email', {message: 'Invalid query'});
          }
        })}
      >
        <Box sx={{display: 'flex', gap: 2, mb: 2, alignItems: 'top'}}>
          <TextField
            sx={{borderRadius: '8px', width: '100%'}}
            {...form.register('email')}
            label="Email"
            variant="outlined"
            error={!!form.formState.errors.email}
            helperText={form.formState.errors.email?.message}
          />

          <ButtonWithProgress
            sx={createButton}
            loading={isLoading}
            type="submit"
          >
            Get Token
          </ButtonWithProgress>
        </Box>
      </form>
      <Box>
        {isLoading && <p>Loading...</p>}
        {data ? (
          <Box mt={4}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Token Information
                </Typography>
                <Divider sx={{mb: 2}} />
                <Stack spacing={1}>
                  <Typography variant="body1">
                    <strong>Access Token:</strong> {data.accessToken}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Refresh Token:</strong> {data.refreshToken}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Token Expiration:</strong>{' '}
                    {data.accessTokenExpiration}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Role:</strong> {data.role}
                  </Typography>
                  {isSuccess ? (
                    <Box>
                      <ButtonWithProgress sx={createButton} onClick={signIn}>
                        Sign in
                      </ButtonWithProgress>
                    </Box>
                  ) : null}
                </Stack>
              </CardContent>
            </Card>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default GetTokenPage;
